import { FunctionComponent, Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { ROUTES } from '../constants/routes';
import MapPage from './map';
import { useId } from 'react-id-generator';

const HomePage = lazy(() => import('./home'));
const MessagesPage = lazy(() => import('./messages'));
const MessagePage = lazy(() => import('./message'));
const NewMessagePage = lazy(() => import('./new-message'));
const EditMessagePage = lazy(() => import('./edit-message'));
const StatsPage = lazy(() => import('./stats'));
const SupportPage = lazy(() => import('./support'));
const ProfilePage = lazy(() => import('./profile'));
const TermsOfUsePage = lazy(() => import('./terms-of-use'));
const MyMessagesPage = lazy(() => import('./my-messages'));
const newMessageSuccessPage = lazy(() => import('./new-message/success'));
const AuthorizedPage = lazy(() => import('./authorized'));
const BookmarksPage = lazy(() => import('./bookmarks'));
const VilniusLoginPage = lazy(() => import('./signin/vilnius-login'));

interface PagesProps {}

const pages = [
  { path: ROUTES.home, element: HomePage },
  { path: ROUTES.messages, element: MessagesPage },
  { path: ROUTES.message, element: MessagePage },
  { path: ROUTES.editMessage, element: EditMessagePage },
  { path: ROUTES.newMessage, element: NewMessagePage },
  { path: ROUTES.map, element: MapPage },
  { path: ROUTES.stats, element: StatsPage },
  { path: ROUTES.support, element: SupportPage },
  { path: ROUTES.profile, element: ProfilePage },
  { path: ROUTES.termsOfUse, element: TermsOfUsePage },
  { path: ROUTES.myMessages, element: MyMessagesPage },
  { path: ROUTES.newMessageSuccess, element: newMessageSuccessPage },
  { path: ROUTES.authorized, element: AuthorizedPage },
  { path: ROUTES.bookmarks, element: BookmarksPage },
  { path: ROUTES.vilniusLogin, element: VilniusLoginPage },
];

const Pages: FunctionComponent<PagesProps> = () => {
  const ids = useId(pages.length);

  return (
    <Suspense>
      <Routes>
        {pages.map((page, i) => (
          <Route key={ids[i]} element={<page.element />} path={page.path} />
        ))}
      </Routes>
    </Suspense>
  );
};

export default Pages;
